module.exports = __webpack_public_path__ + "static/00069.bca46df9.jpg";